<template>
  <div>
    <Modal
      :title="$t('global.edit-default-payment')"
      @close="close"
      @confirm="confirm"
      :hide-footer="true"
    >
      <template #body>
        <DefaultPaymentEditForm
          :client-id="data.clientId"
          :client-options="clientOptions"
          :paymentType="data.paymentType"
          v-on="$listeners"
        />
      </template>
    </Modal>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import DefaultPaymentEditForm from "@/components/smart/forms/DefaultPaymentEditForm";
import Modal from "@/components/display/Modal";
import store from "@/store";

export default {
  name: "DefaultPaymentEditModal",
  props: {
    data: Object,
  },
  components: {
    Modal,
    DefaultPaymentEditForm,
  },
  setup(props, { emit }) {
    onMounted(() => {
      store.dispatch("auth/clientOptions");
    });

    const clientOptions = computed(() => store.getters["auth/getClientOptions"]);

    const close = () => {
      emit("close");
    };

    const confirm = () => {
      emit("confirm");
    };

    return {
      clientOptions,
      close,
      confirm,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
</style>
